<script setup>
import { useBreakpoints } from '@daysmart/daysmart-vue-components/composables'
import { useCalendarViewState } from '../composables/useCalendarViewState'

const props = defineProps(['date', 'eventDates'])
const emit = defineEmits(['selectDate'])

const { current: currentBreakpoint } = useBreakpoints()
const view = useCalendarViewState()

const isMobileView = computed(
  () => currentBreakpoint.value === 'sm' || currentBreakpoint.value === 'xs',
)

function selectDate(day) {
  emit('selectDate', day)
}
</script>

<template>
  <ScheduleMonthViewDateControl v-if="!isMobileView && view === 'month'" />
  <ScheduleWeekViewDateControl
    v-if="!isMobileView && view === 'week'"
    :date="date"
  />
  <ScheduleDayViewDateControl
    v-if="isMobileView || view === 'day'"
    :date="date"
    :event-dates="eventDates"
    @select-date="selectDate"
  />
</template>
